import { render, staticRenderFns } from "./QueryMarmotI.vue?vue&type=template&id=79e88514&"
import script from "./QueryMarmotI.vue?vue&type=script&lang=js&"
export * from "./QueryMarmotI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports